import { createReducer, on } from '@ngrx/store';
import * as OpportunityApprovalsActions from './opportunity-approvals.actions';
import { OpportunityApprovalsState } from './opportunity-approvals.state';

export const initialState: OpportunityApprovalsState = {
  approvals: [],
  loading: false,
  error: null,
};

export const opportunityApprovalsReducer = createReducer(
  initialState,
  on(OpportunityApprovalsActions.loadOpportunityApprovals, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(OpportunityApprovalsActions.loadOpportunityApprovalsSuccess, (state, { approvals }) => ({
    ...state,
    approvals,
    loading: false,
  })),
  on(OpportunityApprovalsActions.loadOpportunityApprovalsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(OpportunityApprovalsActions.createOpportunityApprovalSuccess, (state, { approval }) => ({
    ...state,
    approvals: [...state.approvals, approval],
  })),
  on(OpportunityApprovalsActions.createOpportunityApprovalsBatchSuccess, (state, { approvals }) => ({
    ...state,
    approvals: [...state.approvals, ...approvals],
  })),
  on(OpportunityApprovalsActions.updateOpportunityApprovalSuccess, (state, { approval }) => ({
    ...state,
    approvals: state.approvals.map((a) => (a.id === approval.id ? approval : a)),
  }))
);
